import { PersonTypes } from '@frontend/api-person';
import { ModalControlResponse } from '@frontend/design-system';
import { VerifyInsuranceSidePanel, VerificationMetricSidePanel } from '../../components';
import { InsuranceProvider } from '../../providers/insurance-provider';
import { InsuranceTypeProvider } from '../../providers/insurance-type-provider';
import { PersonInfoStoreProvider } from '../../providers/person-info-provider';
import { DateRangeOptionValue } from '../../utils/constants';

type UseGetAppointmentDetailsProps = {
  verifyInsuranceModalControl: ModalControlResponse;
  verificationMetricModalControl: ModalControlResponse;
  defaultDateRange: DateRangeOptionValue;
  setDefaultDateRange: (dateRange: DateRangeOptionValue) => void;
  personInfo?: PersonTypes.Person;
  locationId: string;
  shouldShowTuuthFairyReport?: boolean;
  hasVerificationError?: boolean;
  useModal?: boolean;
  /**
   * When opening verify insurance from the eligibility list view, pass the
   * currently displayed appointment date so the matching list query can be
   * invalidated by exact key after verify action.
   */
  eligibilityListAppointmentDate?: string;
};

export const useGetInsuranceVerificationModal = ({
  verifyInsuranceModalControl,
  verificationMetricModalControl,
  defaultDateRange,
  setDefaultDateRange,
  personInfo,
  locationId,
  shouldShowTuuthFairyReport = false,
  hasVerificationError = false,
  useModal = true,
  eligibilityListAppointmentDate,
}: UseGetAppointmentDetailsProps) => {
  const handleReportLearnMoreClick = () => {
    setDefaultDateRange('this-month');
    verificationMetricModalControl.openModal();
  };
  return {
    Modal: (
      <PersonInfoStoreProvider personInfo={personInfo} locationId={locationId}>
        <InsuranceTypeProvider>
          {/**
          verifyInsuranceSidePanel relies only  on the insurance-details API and insurance-verification-details API is disabled since the required
          verification data is already available from insurance-details.
         */}
          <InsuranceProvider personInfo={personInfo} locationId={locationId} disableFetchingVerificationData={true}>
            <VerifyInsuranceSidePanel
              shouldShowTuuthFairyReport={shouldShowTuuthFairyReport}
              hasVerificationError={hasVerificationError}
              useModal={useModal}
              eligibilityListAppointmentDate={eligibilityListAppointmentDate}
              {...verifyInsuranceModalControl.modalProps}
              onReportLearnMoreClick={() => handleReportLearnMoreClick()}
            />
          </InsuranceProvider>
          <VerificationMetricSidePanel {...verificationMetricModalControl.modalProps} dateRange={defaultDateRange} />
        </InsuranceTypeProvider>
      </PersonInfoStoreProvider>
    ),
  };
};
